import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComponentType, ScrollStrategyOptions } from '@angular/cdk/overlay';

/**
 * Service APIs for loading components in modals
 */
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(
    private dialog: MatDialog,
    private scrollStrategyOptions: ScrollStrategyOptions,
  ) {}

  /**
   * Opens a component in a dialog window with the given data
   * Note: Target component must have an @Inject(MAT_DIALOG_DATA) in the ctor
   * in order for the data to be passed
   *
   * @param componentType The type of component to open
   * @param data The data to pass to the component
   * @param widthPx The width of the dialog in px
   * @param wide If true, uses a wider panel class with maxWidth: 90vw
   */
  openDialog<T>(
    componentType: ComponentType<T>,
    data: object,
    widthPx: number = 789,
    wide: boolean = false,
  ): MatDialogRef<T> {
    return this.dialog.open(componentType, {
      data: data,
      width: wide ? '90vw' : `${widthPx}px`,
      maxWidth: wide ? `${Math.max(widthPx, 1100)}px` : `${widthPx}px`,
      maxHeight: 'calc(100vh - 80px)',
      position: { top: '40px' },
      backdropClass: 'dialog-backdrop',
      panelClass: wide ? 'dialog-panel-wide' : 'dialog-panel',
      scrollStrategy: this.scrollStrategyOptions.block(),
    });
  }
}
